import { jsx, jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope } from "@radix-ui/react-context";
const INPUT_NAME = "Input";
const [createInputContext, createInputScope] = createContextScope(INPUT_NAME);
const [InputContextProvider, useInputContext] = createInputContext(INPUT_NAME);
function Input(inputProps) {
    const { __scopeInput, children, disabled, loaderPosition = "prefix", loading, prefix, readOnly, spinner, suffix, ...props } = inputProps;
    const inputRef = useRef(null);
    const handlePointerDown = (event)=>{
        const target = event.target;
        if ("input" === target.tagName.toLowerCase() || target.closest("input, a, button")) return void event.stopPropagation();
        const inputElement = inputRef.current;
        if (!inputElement) return;
        if (document.activeElement === inputElement) return void event.preventDefault();
        requestAnimationFrame(()=>{
            if ("file" === inputElement.type) return void inputElement.click();
            if (document.activeElement !== inputElement) inputElement.focus();
        });
    };
    return /*#__PURE__*/ jsx(InputContextProvider, {
        disabled: disabled,
        inputRef: inputRef,
        readOnly: readOnly,
        scope: __scopeInput,
        children: /*#__PURE__*/ jsxs("div", {
            "data-disabled": disabled,
            "data-readonly": readOnly,
            role: "presentation",
            onPointerDown: handlePointerDown,
            ...props,
            children: [
                loading && "prefix" === loaderPosition ? spinner : prefix,
                children,
                loading && "suffix" === loaderPosition ? spinner : suffix
            ]
        })
    });
}
const INPUT_FIELD_NAME = "InputField";
function InputField({ __scopeInput, ...props }) {
    const { disabled, inputRef, readOnly } = useInputContext(INPUT_FIELD_NAME, __scopeInput);
    const composedInputRef = useComposedRefs(inputRef);
    return /*#__PURE__*/ jsx("input", {
        ref: composedInputRef,
        disabled: disabled,
        readOnly: readOnly,
        type: "text",
        ...props
    });
}
export { InputField as Field, Input, InputField, Input as Root, createInputScope };
